<template>
  <toggle-button-group :options="periodOptions" @change="handleChange" />
</template>

<script>
import toggleButtonGroup from '../../../toggleButton/toggleButtonGroup.vue';

export default {
  name: 'RidershipPeriodToggle',
  components: { toggleButtonGroup },
  props: {
    selectedPeriod: {
      type: String,
      default: 'timeOfDay',
    },
  },
  computed: {
    periods() {
      return [
        { value: 'date', label: this.$t('flexigo.ridership.byDate') },
        { value: 'timeOfDay', label: this.$t('flexigo.ridership.byTimeOfDay') },
        { value: 'dayOfWeek', label: this.$t('flexigo.ridership.byWeekday') },
      ];
    },
    periodOptions() {
      return this.periods.map(({ label, value }) => ({
        label,
        selected: value === this.selectedPeriod,
      }));
    },
  },
  methods: {
    handleChange({ index }) {
      this.$emit('change', this.periods[index].value);
    },
  },
};
</script>
